import "./SurveyMeetingStatePill.scss";

import { Text } from "@fluentui/react-northstar";
import { SurveyDTO } from "@teams/types/api";
import React, { useMemo } from "react";

type Props = {
  survey: SurveyDTO;
};

export const SurveyMeetingStatePill: React.FC<Props> = ({ survey }) => {
  const { className, label } = useMemo((): { className: string; label: React.ReactNode } => {
    switch (survey.state) {
      case "open":
        return { className: "survey-meeting-state-pill__open", label: "Live" };
      case "closed":
        return { className: "survey-meeting-state-pill__closed", label: "Closed" };
      case "pending":
        return { className: "survey-meeting-state-pill__pending", label: "Ready" };
      default:
        return { className: "", label: survey.state };
    }
  }, [survey.state]);

  return (
    <Text
      align="center"
      as="div"
      className={`survey-meeting-state-pill ${className}`}
      weight="bold"
      size="small"
      content={label}
    />
  );
};
